import Index from "views/Index.js";
import Paineis from "views/Paineis.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Icons from "views/examples/Icons.js";

import AdminLayout from "layouts/AdminLayout.js";
import AuthLayout, {action as authAction} from "layouts/AuthLayout.js";
import Login from "views/Login.js";
import RecuperarSenha, {action as recuperarSenhaAction} from "views/RecuperarSenha.js";
import Reports from "views/Reports";
import ReportDisponibilidade from "views/ReportDisponibilidade.js";
import { Navigate } from "react-router-dom";

var routes = [
  {
    path: "/",
    element: <AuthLayout />,
    action: authAction,
    children: [
      {index: true, element: <Login />},
      {
        path: "login",
        element: <Login />,
      },  
      {
        path: "recover",
        element: <RecuperarSenha />,
        action: recuperarSenhaAction        
      },    
      {
        path: "recover/login",
        action: recuperarSenhaAction        
      },        
      {
        path: "*",
        element: <Navigate to="/login" replace={true} />,
      }
    ]
  },  
  {
    path: "/admin",
    element: <AdminLayout />,
    name: "Admin-ProsperBPO",
    icon: "ni ni-tv-2 text-primary",
    children: [
      {index: true, element: <Paineis />},
      {
        path: "paineis",
        element: <Paineis />,
        name: "Painéis",
        icon: "ni ni-tv-2 text-primary",
      },
      {
        path: "index",
        element: <Index />,
        name: "Dashboard",
        icon: "ni ni-tv-2 text-primary",
      },
      {
        path: "reports",
        element: <Reports />,
        name: "Relatórios",
        icon: "ni ni-bullet-list-67 text-orange",
      },    
      {
        path: "report_disponibilidade",
        element: <ReportDisponibilidade />,
        name: "Relatório Disponibilidade",
        icon: "ni ni-bullet-list-67 text-orange",
      },    
      {
        path: "icons",
        element: <Icons />,        
        name: "Icons",
        icon: "ni ni-planet text-red",
      },
      {
        path: "maps",
        element: <Maps />,
        name: "Maps",
        icon: "ni ni-pin-3 text-orange",
      },
      {
        path: "user-profile",
        element: <Profile />,
        name: "User Profile",
        icon: "ni ni-single-02 text-yellow",
      },
    ]
  },    
];
export default routes;
